import { render, staticRenderFns } from "./LottieAnimation.vue?vue&type=template&id=6f37acaf&scoped=true&"
import script from "./LottieAnimation.vue?vue&type=script&lang=js&"
export * from "./LottieAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LottieAnimation.vue?vue&type=style&index=0&id=6f37acaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37acaf",
  null
  
)

export default component.exports